import { NavMarker } from 'react-rhumb';
import { useAreInitialCardsReady } from 'crm-cards-sdk/internal/perf/cardPerfSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
export const InitialCardsReadyRhumb = ({
  location
}) => {
  const initialCardsAreReady = useAreInitialCardsReady();
  if (initialCardsAreReady) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: `LOCATION_${location}_INITIAL_CARDS_READY`
    });
  }
};